export default __webpack_public_path__ + "static/conex-seal-black-0b153ecd6b3f8032cf656e970822f61c.webp";